import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './authMiddleware';

/**
 * ProtectedRoute component - Middleware to protect routes that require authentication
 * Uses the AuthContext for authentication state
 */
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  // Show loading state while checking authentication
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-800"></div>
      </div>
    );
  }

  // If not authenticated, redirect to login page, preserving the intended destination
  if (!isAuthenticated) {
    return <Navigate to="/admin/login" state={{ from: location.pathname }} replace />;
  }

  // If authenticated, render the children components
  return children;
};

export default ProtectedRoute;